import store from '@/store'

const inicializar = async function(to) {
  console.log(to)
  const isCleanerRoute = to.matched.some(route => route.meta.requiresAuthCleaner || route.meta.cleaner)
  const storePrefix = isCleanerRoute ? 'loginCleaner/' : 'login/'
  console.log(storePrefix, isCleanerRoute)
  if (!store.getters[storePrefix + 'loaded']) {
    await store.dispatch(storePrefix + 'restore')
    store.dispatch(storePrefix + 'setLoaded', true)
  }
  return true
}

async function handleAuth(to, next, authType) {
  const storePrefix = authType === 'cleaner' ? 'loginCleaner/' : 'login/'
  const requiresAuthMeta = authType === 'cleaner' ? 'requiresAuthCleaner' : 'requiresAuth'
  const loginRouteName = authType === 'cleaner' ? 'loginCleaner' : 'login'
  const homeRouteName = authType === 'cleaner' ? 'homeCleaner' : 'home'

  if (to.matched.some(route => route.meta[requiresAuthMeta])) {
    if (store.getters[storePrefix + 'loggedIn'] && !store.getters[storePrefix + 'sessionChecked']) {
      // Comprobar sesión
      store.dispatch(storePrefix + 'setCheckingSession', true)
      await store.dispatch(storePrefix + 'checkSession')
      store.dispatch(storePrefix + 'setCheckingSession', false)
    }
    if (!store.getters[storePrefix + 'loggedIn'] && !store.getters[storePrefix + 'sessionChecked']) {
      // Comprobar que estoy logueado
      next({ name: loginRouteName })
      return false
    }
  } else {
    if (
      store.getters[storePrefix + 'loggedIn'] &&
      to.name === loginRouteName &&
      !store.getters[storePrefix + 'sessionChecked']
    ) {
      next({ name: homeRouteName })
      return true
    }
  }
  return true // Permitir la navegación por defecto
}

const beforeEach = async function(to, from, next) {
  store.dispatch('login/setCheckingSession', false)

  try {
    if (await inicializar(to)) {
      if (to.matched.some(route => route.meta.requiresAuthCleaner)) {
        if (!(await handleAuth(to, next, 'cleaner'))) return
      }
      if (to.matched.some(route => route.meta.requiresAuth)) {
        if (!(await handleAuth(to, next, 'user'))) return
      }
      next() // Permitir navegación si todo está bien
    }
  } catch (error) {
    next({ name: 'login' })
  }
}

export default beforeEach
